import { KgLoadingStatus } from '@/types/schema';

import { HouseholdLoading_StateFragment } from './graphql/KGLoading.generated';

export function householdLoadingPreview(
  state: HouseholdLoading_StateFragment,
  { keepCompletedPreview = false }: { keepCompletedPreview?: boolean } = {}
) {
  // The server omits sessions that are not usable as previews. In retained
  // mode, preserve that selection through staggered completion and failures.
  const sessions = keepCompletedPreview
    ? state.sessions
    : state.sessions.filter(
        (session) => session.status === KgLoadingStatus.Processing
      );
  // Revisions restart in each session. Keep concurrent attempts independent.
  const documents = sessions.flatMap((session) =>
    session.documents.map((document) => ({
      ...document,
      namespace: [session.id, document.documentID],
    }))
  );
  const nodes = documents.flatMap((document) =>
    document.nodes.map((node) => ({
      ...node,
      id: JSON.stringify([...document.namespace, node.id]),
    }))
  );
  const ids = new Set(nodes.map((node) => node.id));
  const relationships = documents
    .flatMap((document) =>
      document.relationships.map((edge) => ({
        id: JSON.stringify([...document.namespace, edge.id]),
        kind: edge.kind,
        sourceID: JSON.stringify([...document.namespace, edge.sourceID]),
        targetID: JSON.stringify([...document.namespace, edge.targetID]),
      }))
    )
    .filter((edge) => ids.has(edge.sourceID) && ids.has(edge.targetID));
  return { nodes, relationships, sessions };
}
